import { render, staticRenderFns } from "./HeaderTab.vue?vue&type=template&id=4bf826e5&scoped=true&"
import script from "./HeaderTab.vue?vue&type=script&lang=js&"
export * from "./HeaderTab.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTab.vue?vue&type=style&index=0&id=4bf826e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf826e5",
  null
  
)

export default component.exports